import React from 'react';
import wrapComponent from "../core/wrapComponent";
import * as R from 'unitx/ramda';
import Tree from "./Tree";
import { View, Text } from "./native";

const JSONViewer = props => {
  const {
    data
  } = props;
  const processedData = React.useMemo(() => R.toJSONItemList(data), [data]);
  return /*#__PURE__*/React.createElement(Tree, {
    data: processedData,
    accessor: ['properties'],
    renderItem: ({
      item
    }) => {
      const {
        key,
        value
      } = item;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row'
        }
      }, /*#__PURE__*/React.createElement(Text, {
        category: "label"
      }, `${key}${value ? ': ' : ''}`), value ? /*#__PURE__*/React.createElement(Text, {
        category: "label"
      }, value) : null);
    }
  });
};

export default wrapComponent(JSONViewer);